<template>
    <div>
        <div v-if="display" class="custom-footer">
            <div class="clickable" @click="$router.replace({ path: '/home' })">
                <img src="../../../public/resources/images/custom-footer-icons/home.png" />
                <br />
                <span class="fs-13 fw-600">Home</span>
            </div>
            <div class="clickable" @click="$router.replace({ path: '/debenture' })">
                <img src="../../../public/resources/images/custom-footer-icons/debenture.png" />
                <br />
                <span class="fs-13 fw-600">Debenture</span>
            </div>
            <div class="clickable" @click="$router.replace({ path: '/ticket' })">
                <img src="../../../public/resources/images/custom-footer-icons/ticket.png" />
                <br />
                <span class="fs-13 fw-600">Ticket</span>
            </div>
            <!-- <div class="clickable" @click="modal_visible = true">
            <img src="../../../public/resources/images/custom-footer-icons/chat.png" />
            <br />
            <span class="fs-13 fw-600">Chat</span>
        </div> -->
            <div class="clickable" @click="$router.replace({ path: '/ticket-system-report' })">
                <img src="../../../public/resources/images/custom-footer-icons/help.png" />
                <br />
                <span class="fs-13 fw-600">Help</span>
            </div>
        </div>
        <modal-form ref="modalForm" :visible="modal_visible" v-if="modal_visible" :data="modal_data" @on-cancel="onModalCancel" />
    </div>
</template>
<script>
import modalForm from './modalForm';
import _ from 'lodash';
const displayRoutes = ['/home', '/activity', '/privilege', '/reward', '/debenture', '/delight', '/log', '/chat', '/inbox', '/favorite', '/search'];
export default {
    components: {
        modalForm,
    },
    props: [],
    data() {
        return {
            display: false,
            modal_data: {},
            modal_visible: false,
        };
    },
    mounted() {},
    methods: {
        onModalCancel() {
            this.modal_visible = false;
            this.modal_data = {};
        },
    },
    watch: {
        $route(newVal, oldVal) {
            this.display = _.includes(displayRoutes, newVal.path);
        },
    },
};
</script>
<style scoped>
.custom-footer {
    position: fixed;
    bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 12px 22px 40px;
    gap: 7%;
    background: #ffffff;
    box-shadow: 0px -10px 20px rgba(0, 0, 0, 0.05);
    border-radius: 24px 24px 0px 0px;
    width: 100%;
    height: calc(100vh * 0.1479);
    z-index: 9998;
}
.custom-footer div {
    vertical-align: top;
    display: inline-block;
    text-align: center;
    width: calc(25% - 16px);
}
.custom-footer img {
    /* width: 20%; */
    width: 100%;
}
.custom-footer div span {
    display: block;
}
/* @media screen and (min-width: 768px) {
    .custom-footer {
        width: 63%;
        height: calc(85vh * 0.1479);
    }
}
@media screen and (min-width: 810px) {
    .custom-footer {
        width: 60%;
        height: calc(80vh * 0.1479);
    }
}
@media screen and (min-width: 1024px) {
    .custom-footer {
        width: 47%;
        height: calc(75vh * 0.1479);
    }
} */
@media only screen and (min-device-width: 480px) {
    .custom-footer {
        width: 480px;
    }
}
@media only screen and (min-device-width: 768px) and (min-height: 1024px) {
    .custom-footer {
        height: calc(85vh * 0.1479);
    }
}
@media only screen and (min-device-width: 768px) and (min-height: 1180px) {
    .custom-footer {
        height: calc(80vh * 0.1479);
    }
}
@media only screen and (min-device-width: 768px) and (min-height: 1366px) {
    .custom-footer {
        height: calc(70vh * 0.1479);
    }
}
/* @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    .custom-footer {
        height: calc(70vh * 0.1479);
    }
} */
@media only screen and (min-device-width: 1025px) {
    /* styles for screens with a maximum width of 768 pixels */
    .custom-footer {
        height: 128px;
    }
}
</style>
